// PROBABLY DON'T TOUCH THIS FILE
// THIS HAS TO BE FIRST FOR REASONS
import { polyfill } from "./core/Polyfills";
polyfill();

import { main } from "./mariana/main";
main();
